module.exports = __webpack_public_path__ + "img/pmsm1.2dc34764.png";